module.exports = __webpack_public_path__ + "img/register-tip.4ff03a20.png";